import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'principalAndInterest',
    label: 'Principal & Interest',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'secondaryFinancing',
    label: 'Secondary Financing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'mortgageInsurance',
    label: 'Mortgage Insurance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'propertyTaxes', label: 'Property Taxes', levelType: AutoLockFormsLevelType.FIELD },
  {
    name: 'homeownersInsurance',
    label: 'Homeowners Insurance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'supplementalInsurance',
    label: 'Supplemental Insurance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'homeownersAssociation', label: 'HOA Dues', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'otherExpenses', label: 'Other Expenses', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'piti', label: 'PITI', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'escrow', label: 'Escrow', levelType: AutoLockFormsLevelType.FIELD },
];

export const existingPropertyExpensesForm = {
  name: FormNames.EXISTING_PROPERTY_EXPENSES,
  label: 'Existing Property Expenses',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
